export default {
  id: 64,
  title: 'Target #64 - Door Knob',
  url: 'https://cssbattle.dev/play/64',
  colors: ['#191919', '#E08027', '#824B20', '#FFF58F'],
  solution:
    '<a a><a b><a c><style>body{background:#191919}a{position:fixed;border-radius:50%}a[a]{top:70;left:120;width:100;height:100;background:#e08027;border:30px solid #824b20}a[b]{top:90;left:140;width:80;height:80;border:20px solid #fff58f;clip-path:inset(60px 0 0 0)}a[c]{top:140;left:140;width:20;height:20;background:#fff58f;box-shadow:100px 0 #fff58f}</style>',
}
